import { Col, Row } from "antd";
import { t } from "i18next";
import React, { useContext } from "react";

import { Button } from "../../../../../components/Button/Button";
import CollapseArrayView from "../../../../../components/CollapseArrayView/CollapseArrayView";
import { ModalsContext } from "../../../../../context/modals.context";
import { IMarkicaZahteviDrustvoInfoDtoProps } from "../../../../../modules/obligee/exciseStamps/exciseStamps.types";
import { AuthorizedPersonsModal } from "../../../../Obligee/ExciseStamp/components/UserInfo/components/AuthorizedPersonsModal/AuthorizedPersonsModal";
import style from "./StampsUserInfo.module.scss";

interface IStampsUserInfoProps {
  exciseStampsInfo: IMarkicaZahteviDrustvoInfoDtoProps;
}

export const StampsUserInfo: React.FC<IStampsUserInfoProps> = ({
  exciseStampsInfo,
}) => {
  const { handleUpdateModals } = useContext(ModalsContext);
  const handleButtonClick = () => {
    handleUpdateModals({ modalVisible: "authorizedPersons" });
  };
  return (
    <Col className={style.mainContainer} span={24}>
      <AuthorizedPersonsModal
        tableData={exciseStampsInfo.ovlascenaLicaZaPreuzimanjeMarkica}
      />
      <Col className={style.title} span={24}>
        {t("AKCIZNE_MARKICE.PODACI_O_PODNOSIOCU_ZAHTEVA")}
      </Col>
      <Row>
        <Col className="mb-25" span={5}>
          <span className={style.fontSize}>{t("AKCIZNE_MARKICE.NAZIV")}:</span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>{exciseStampsInfo.naziv}</span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {t("AKCIZNE_MARKICE.SIFRA_DELATNOSTI")}:
          </span>
        </Col>
        <Col span={3}>
          <span className={style.fontSize}>
            {exciseStampsInfo.preteznaDelatnost}
          </span>
        </Col>
        <Col span={2}>
          <Button
            className={style.button}
            onClick={handleButtonClick}
            type="primary"
          >
            {t("AKCIZNE_MARKICE.SPISAK_OVLASCENIH_LICA_ZA_PREUZIMANJE_MARKICA")}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col className="mb-25" span={5}>
          <span className={style.fontSize}>
            {t("AKCIZNE_MARKICE.MESTO_I_ADRESA")}:
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {`${
              exciseStampsInfo.imeGrada ? `${exciseStampsInfo.imeGrada}, ` : ""
            }${exciseStampsInfo.adresa}`}
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>{t("AKCIZNE_MARKICE.PIB")}:</span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>{exciseStampsInfo.pib}</span>
        </Col>
      </Row>
      <Row>
        <Col span={5}>
          <span className={style.fontSize}>
            {t("AKCIZNE_MARKICE.MATICNI_BROJ")}:
          </span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>{exciseStampsInfo.maticniBroj}</span>
        </Col>
        <Col span={5}>
          <span className={style.fontSize}>
            {t("AKCIZNE_MARKICE.BROJ_TEKUCEG_RACUNA")}:
          </span>
        </Col>
        <Col span={5}>
          {exciseStampsInfo.brojTekucegRacuna
            ?.slice(0, 3)
            ?.map((racun, index) => (
              <Row key={index}>{racun}</Row>
            ))}
          {exciseStampsInfo.brojTekucegRacuna?.slice(3)?.length ? (
            <CollapseArrayView
              elementKey="brojTekucegRacuna"
              items={exciseStampsInfo.brojTekucegRacuna}
            />
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </Col>
  );
};
